import { FeaturedCategory, FeaturedProducts, Hero } from "../../components";

export default function HomePage() {
  return (
    <main>
      <Hero />
      <FeaturedCategory />
      <FeaturedProducts />
    </main>
  );
}
